import type { AuthError } from '@azure/msal-common';
import type { SupportedLocale } from '@brightdrop/localization-core';

import {
  AuthenticationType,
  type AuthType,
} from '~/models/authentication.model';

/** The query parameter each B2C policy reads its display language from. */
const B2C_LOCALE_QUERY_PARAM: Record<AuthType, string> = {
  [AuthenticationType.CDI]: 'ui_locales',
  [AuthenticationType.SSO]: 'mkt',
};

/**
 * Builds the extra query parameters that carry the locale to the B2C
 * authorize call: `ui_locales` for customer (CDI) login, `mkt` for SSO.
 * @param authType - The auth type the MSAL instance was built for
 * @param locale - The locale B2C should render in
 * @returns A single-entry map to merge into `extraQueryParameters`
 */
export const getB2cLocaleQueryParameters = (
  authType: AuthType,
  locale: SupportedLocale
): Record<string, string> => ({
  [B2C_LOCALE_QUERY_PARAM[authType]]: locale,
});

export const isMSALAuthError = (err: Error): err is AuthError => {
  return err && Object.hasOwn(err, 'errorCode');
};
